import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

  type QuizDTO = object & ApiError

export const AddToCart = (courseId:string): Promise<QuizDTO> => {
    return axios.post(`/cart/addCourseToCart/${courseId}`)
        .then(response => response.data as QuizDTO);
};
